import axios from "axios";
import Config from "../Config";

export default {
  // 세션키 생성 API
  getSessionKey(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/sessionkey";
    return axios.post(url, param, config);
  },
  // 약관 목록 API
  getTermList(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/need/terms";
    return axios.get(url, config);
  },
  // 통합 약관 등록 API
  insertTerm(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/terms";
    return axios.post(url, param, config);
  },
  // 서비스 약관 등록 API
  insertServiceTerm(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/service/terms";
    return axios.post(url, param, config);
  },
  // ID 중복 확인
  usableId(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/usable/id";
    return axios.post(url, param, config);
  },
  // 점유 인증 요청 API
  requestPossession(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/possession";
    return axios.post(url, param, config);
  },
  // 점유 인증 확인 API
  checkPossession(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/verify/possession";
    return axios.post(url, param, config);
  },
  // PASS 본인 인증 request 정보 요청 API
  requestInfoPassVerify(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/person";
    return axios.post(url, param, config);
  },
  // PASS 본인 인증 요청 API
  requestPassVerify(param) {
    const url = "https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v2.jsp";
    return axios.post(url, param);
  },
  // PASS 본인 인증 확인 API
  checkPassVerify(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/verify/person";
    return axios.post(url, param, config);
  },
  // 회원가입 API
  signUp(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/registration";
    return axios.post(url, param, config);
  },
  // SNS 회원가입 API
  snsSignUp(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/registration/sns";
    return axios.post(url, param, config);
  },
  // 회원 정보 조회 API
  getUserInfo(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user";
    return axios.get(url, config);
  },
  // 서비스별 회원유형 목록 조회 API
  getServiceUserTypeList(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/need/type";
    return axios.get(url, config);
  },
  // 서비스별 회원유형 선택 API
  insertServiceUserType(param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/service/${param.serviceId}/save/type`;
    return axios.post(url, param, config);
  },
  // 서비스 등록 API
  insertService(param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/service/${param.serviceId}/registration`;
    return axios.post(url, param, config);
  }
};
